import React from 'react'

import { Button } from '@/components/buttons/Button'
import { Card } from '@/components/cards/Card'
import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'
import Select from '@/components/forms/Select'

export const AddTagsCard = ({
  tagGroup,
  onTagGroupChange,
  category,
  onCategoryChange,
  tagCategories,
  onSubmit,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault()
    onSubmit()
  }

  return (
    <Card
      compact
      title="Add new tags"
      subtitle="Separate multiple tags with commas. Tag names can't contain spaces."
    >
      <form className="manage-tags__add-form" onSubmit={handleSubmit}>
        <FormField>
          <label htmlFor="tag-names-input">Tag names</label>
          <TextInput
            id="tag-names-input"
            placeholder="refund-request, escalation, promo-offer"
            value={tagGroup}
            onChange={onTagGroupChange}
          />
        </FormField>
        <FormField>
          <label htmlFor="tag-category-select">Category</label>
          <Select
            inputId="tag-category-select"
            placeholder="Uncategorized"
            options={tagCategories}
            value={category}
            onChange={onCategoryChange}
          />
        </FormField>
        <Button brand type="submit" data-testid="add_tags_button" disabled={!tagGroup}>
          Add tags
        </Button>
      </form>
    </Card>
  )
}
